export class Issue {
  constructor({ id, name } = {}) {
    this.id = id;
    this.name = name;
  }
}
